module.exports = __webpack_public_path__ + "img/notification.265ebe6e.png";